export const Cities = [
  {
    name: "Alberton",
    suburbs: ["Alberton"]
  },
  {
    name: "Cape Town",
    suburbs: [
      "Acacia Park",
      "Athlone",
      "Bellville",
      "Blouberg",
      "Bo Kaap",
      "Camps Bay",
      "CBD",
      "Century City Ext",
      "Claremont",
      "Constantia",
      "De Waterkant",
      "Durbanville",
      "Foreshore",
      "Gardens",
      "Green Point",
      "Harfield Village",
      "Hout Bay",
      "Kenilworth",
      "Kraaifontein",
      "Meadowridge",
      "Milnerton",
      "Mowbray",
      "Newlands CPT",
      "Observatory",
      "Panorama",
      "Parklands",
      "Parow",
      "Pinelands",
      "Plattekloof",
      "Rondebosch",
      "Salt River",
      "Sea Point",
      "Steenberg",
      "Tamboerskloof",
      "Tokai",
      "Tyger Waterfront",
      "Tygervalley Ext",
      "Vredehoek",
      "Vredekloof",
      "Waterfront",
      "Westlake",
      "Westlake Business Park",
      "Woodstock"
    ]
  },
  {
    name: "Centurion",
    suburbs: [
      "Centurion Central",
      "Clubview",
      "Die Hoewes",
      "Doringkloof",
      "Hennopspark",
      "Lyttelton Manor"
    ]
  },
  {
    name: "Durban",
    suburbs: [
      "Durban Central",
      "Durban North",
      "Glenashley",
      "Glenwood",
      "Morningside",
      "New Germany",
      "Stamford Hill",
      "Umhlanga Ext",
      "Umhlanga Ridge",
      "Umhlanga Rocks",
      "Westville"
    ]
  },
  {
    name: "Franschhoek",
    suburbs: ["Franschhoek"]
  },
  {
    name: "Johannesburg",
    suburbs: [
      "Atholl",
      "Barbeque Downs",
      "Beaulieu",
      "Bedford Gardens",
      "Bedfordview",
      "Benmore Gardens",
      "Blairgowrie",
      "Braamfontein",
      "Bramley",
      "Broadacres",
      "Bryanston",
      "Craighall",
      "Cresta",
      "Douglasdale",
      "Dunkeld",
      "Edenvale",
      "Emmarentia",
      "Ferndale",
      "Ferreiras Dorp",
      "Florida Glen",
      "Fordsburg",
      "Fourways",
      "Gallo Manor",
      "Glenhazel",
      "Greenside",
      "Hyde Park",
      "Illovo",
      "JHB CBD Ext",
      "Johannesburg CBD",
      "Killarney",
      "Krugersdorp",
      "Kyalami Estate",
      "Kyalami Gardens",
      "Kyalami Park",
      "Linden",
      "Lonehill",
      "Marshalltown",
      "Melrose",
      "Melville",
      "Morningside",
      "Morningside Manor",
      "New Town",
      "Northcliff",
      "Norwood",
      "Parkhurst",
      "Parkmore",
      "Parktown",
      "Parktown North",
      "Parkview",
      "Parkwood",
      "Paulshof",
      "Randburg",
      "Randpark Ridge",
      "Riverclub",
      "Rivonia",
      "Roodepoort",
      "Rosebank JHB",
      "Sandown",
      "Sandton",
      "Savoy",
      "Strubens Valley",
      "Sunninghill",
      "Sunnyside",
      "Waterfall",
      "Waterfall Estate",
      "Weltevredenpark",
      "Woodmead",
      "Wynberg"
    ]
  },
  {
    name: "Kempton Park",
    suburbs: ["Kempton Park"]
  },
  {
    name: "Paarl",
    suburbs: ["Paarl"]
  },
  {
    name: "Pretoria",
    suburbs: [
      "Brooklyn PTA",
      "Constantia Park",
      "Die Wilgers",
      "Equestria",
      "Faerie Glen",
      "Garsfontein",
      "Garsfontein Ext",
      "Hatfield",
      "Hazeldean",
      "Hazelwood",
      "Lynnwood",
      "Lynnwood Manor",
      "Lynnwood Ridge",
      "Menlo Park",
      "Menlyn",
      "Moreletapark",
      "Newlands PTA",
      "Waterkloof Heights"
    ]
  },
  {
    name: "Somerset West",
    suburbs: ["Somerset West"]
  },
  {
    name: "Stellenbosch",
    suburbs: ["Stellenbosch Central", "Stellenbosch Ext"]
  },
  {
    name: "Strand",
    suburbs: ["Strand"]
  }
];



// WEBPACK FOOTER //
// ./src/mockAPI/sample-city-list.js